module.exports = __webpack_public_path__ + "resources/icon-dialog-role-close.622d694edba27025.png";


//////////////////
// WEBPACK FOOTER
// ../src/component/game-lottery/component/lottery-dialog-role/img/icon-dialog-role-close.png
// module id = 817
// module chunks = 0 1